import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUser } from "@fortawesome/free-solid-svg-icons"
import { theme } from "../settings/config"
import {
	lessonTypeDisplayNameOf,
	PRIVATE_LESSON_LABEL,
	playersCountLabel,
	privateLessonSize,
} from "../utils/func.utils"

// Il nome di un tipo di lezione dove lo si legge. Le private si chiamano
// "Privata" e dicono quanti sono con un omino: "Privata · 3 giocatori"
// scritto per esteso allargava i tasselli del riepilogo fino a mettercene
// uno per riga.
//
// L'omino è uno solo, e se i giocatori sono più di uno porta il numero in un
// bollino sull'angolo, come le notifiche: l'etichetta resta larga uguale da
// due a quanti si vuole. Omino e bollino prendono il colore del testo
// intorno; il numero e il bordino che stacca il bollino dall'omino quello
// dello sfondo, che lo sa chi li mette — di norma è quello delle schede.
function LessonTypeLabel({ lessonTypeID, lessonType, background = theme.colors.surface }) {
	const size = privateLessonSize(lessonTypeID)
	if (size === null) return lessonTypeDisplayNameOf(lessonType, lessonTypeID)

	return (
		<span
			style={{
				display: "inline-flex",
				alignItems: "center",
				gap: "0.35em",
				whiteSpace: "nowrap",
			}}>
			{PRIVATE_LESSON_LABEL}
			<span
				role="img"
				aria-label={playersCountLabel(size)}
				title={playersCountLabel(size)}
				style={{
					position: "relative",
					display: "inline-flex",
					alignItems: "center",
					paddingRight: size > 1 ? "0.3em" : 0,
				}}>
				<FontAwesomeIcon icon={faUser} size="xs" />
				{/* Il bollino è disegnato e non scritto: il numero centrato col
				    testo cadeva in basso, perché Poppins ha più spazio sotto le
				    lettere che sopra. Nel disegno il centro è un punto preciso. */}
				{size > 1 && (
					<svg
						viewBox="0 0 12 12"
						aria-hidden="true"
						style={{
							position: "absolute",
							top: "-0.45em",
							right: "-0.35em",
							width: "1em",
							height: "1em",
							overflow: "visible",
						}}>
						<circle
							cx="6"
							cy="6"
							r="5.4"
							fill="currentColor"
							stroke={background}
							strokeWidth="1.2"
						/>
						<text
							x="6"
							y="6"
							dy="0.35em"
							textAnchor="middle"
							fill={background}
							fontSize="7.5"
							fontWeight="700"
							fontFamily="inherit">
							{size}
						</text>
					</svg>
				)}
			</span>
		</span>
	)
}

export default LessonTypeLabel
